export const BASE_URL = 'https://api.0580ddr.com/'



// WEBPACK FOOTER //
// ./src/api/config.js